import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';
import { environment } from './environments/environment';

if (environment.production) {
	console.log = () => undefined;
	console.warn = () => undefined;
	console.info = () => undefined;
	console.debug = () => undefined;
}

bootstrapApplication(AppComponent, appConfig).catch((err) => {
	if (!environment.production) {
		console.error(err);
	}
});
